import { siteConfig } from '../data/siteConfig'

export type LocalCountry = keyof typeof siteConfig.localPrice

// Detecta el país por la zona horaria del dispositivo (sin pedir permisos)
export function detectLocalCountry(): LocalCountry | null {
  let tz = ''
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  } catch {
    return null
  }
  if (/Mexico|Cancun|Merida|Monterrey|Matamoros|Chihuahua|Mazatlan|Hermosillo|Tijuana|Bahia_Banderas|Ojinaga/.test(tz)) return 'MX'
  if (/Bogota/.test(tz)) return 'CO'
  if (/Santiago|Punta_Arenas|Easter/.test(tz)) return 'CL'
  return null
}

export function getLocalPrice() {
  const cc = detectLocalCountry()
  return cc ? siteConfig.localPrice[cc] : null
}

export const allLocalShort = Object.values(siteConfig.localPrice)
  .map((p) => p.short)
  .join(' · ')
